// extracted by mini-css-extract-plugin
module.exports = {"group-holding-info-list-item__group-code--width":"_13EeRcd2YcvfWpdvScEidc","group-holding-info-list-item__position--width":"_3LAhLFuZM3PglO6QQT2Vla"};